// import React, {useState, useEffect} from "react";
// import Layout from "../../Layout";
// import {Typography, Spin, message} from "antd";
//
// const {Title} = Typography;
//
// function Leaderboard() {
//     const [leaderboard, setLeaderboard] = useState([]);
//     const [loading, setLoading] = useState(false);
//
//     const accessToken = localStorage.getItem("accessToken");
//
//     useEffect(() => {
//         fetchLeaderboard();
//     }, []);
//
//     const fetchLeaderboard = async () => {
//         setLoading(true);
//         try {
//             const response = await fetch("http://127.0.0.1:8090/admin/class-leaderboard", {
//                 method: "GET",
//                 headers: {Authorization: `Bearer ${accessToken}`},
//             });
//             if (response.ok) {
//                 const data = await response.json();
//                 const sortedData = data.sort((a, b) => b.total_xp - a.total_xp); // Sort by XP
//                 setLeaderboard(sortedData);
//             } else {
//                 message.error("Failed to fetch leaderboard.");
//             }
//         } catch (error) {
//             console.error("Error fetching leaderboard:", error);
//         } finally {
//             setLoading(false);
//         }
//     };
//
//     return (
//         <>
//             <div className="container mx-auto px-6 py-12 bg-white text-gray-800">
//                 <Title level={2} className="text-center mb-8">Class Leaderboard</Title>
//                 {loading ? (
//                     <div className="flex justify-center">
//                         <Spin size="large"/>
//                     </div>
//                 ) : (
//                     <div className="flex flex-wrap justify-center gap-6">
//                         {leaderboard.map((user, index) => (
//                             <div
//                                 key={user.student_id}
//                                 className={`flex flex-col items-center rounded-lg p-6 shadow-lg ${
//                                     index === 0 ? "border-4 border-yellow-500" : "bg-gray-100"
//                                 }`}
//                                 style={{
//                                     width: "100%",
//                                     maxWidth: "300px",
//                                     textAlign: "center",
//                                     transition: "transform 0.3s",
//                                     transform: "translateY(0)",
//                                     fontFamily: "Gotham, sans-serif",
//                                 }}
//                                 onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-5px)")}
//                                 onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
//                             >
//                                 <div className="text-xl font-bold mb-2">
//                                     {index === 0 && <span className="text-yellow-500">🏆 Top Performer</span>}
//                                     <div>{user.name}</div>
//                                 </div>
//                                 {/*<p className="text-sm text-gray-600 mb-4">{user.email || "Email not provided"}</p>*/}
//                                 <p className="text-2xl font-semibold text-yellow-500 mb-4">
//                                     {user.total_xp} XP
//                                 </p>
//                                 <p className="text-sm mt-4">Rank: <strong>{index + 1}</strong></p>
//                             </div>
//                         ))}
//                     </div>
//                 )}
//             </div>
//         </>
//     );
// }
//
// export default Leaderboard;


// import React, {useState, useEffect} from "react";
// import Layout from "../../Layout";
// import {Typography, Spin, message} from "antd";
//
// const {Title} = Typography;
//
// function Leaderboard() {
//     const [leaderboard, setLeaderboard] = useState([]);
//     const [loading, setLoading] = useState(false);
//
//     const accessToken = localStorage.getItem("accessToken");
//
//     useEffect(() => {
//         fetchLeaderboard();
//     }, []);
//
//     const fetchLeaderboard = async () => {
//         setLoading(true);
//         try {
//             const response = await fetch("http://127.0.0.1:8090/admin/class-leaderboard", {
//                 method: "GET",
//                 headers: {Authorization: `Bearer ${accessToken}`},
//             });
//             if (response.ok) {
//                 const data = await response.json();
//                 const sortedData = data.sort((a, b) => b.total_xp - a.total_xp); // Sort by XP
//                 setLeaderboard(sortedData);
//             } else {
//                 message.error("Failed to fetch leaderboard.");
//             }
//         } catch (error) {
//             console.error("Error fetching leaderboard:", error);
//         } finally {
//             setLoading(false);
//         }
//     };
//
//     return (
//         <>
//             <div className="container mx-auto px-6 py-12 bg-white text-gray-800">
//                 <Title level={2} className="text-center mb-8">Class Leaderboard</Title>
//                 {loading ? (
//                     <div className="flex justify-center">
//                         <Spin size="large"/>
//                     </div>
//                 ) : (
//                     <div className="flex flex-wrap justify-center gap-6">
//                         {leaderboard.map((user, index) => (
//                             <div
//                                 key={user.student_id}
//                                 className={`flex flex-col items-center rounded-lg p-6 shadow-lg ${
//                                     index === 0 ? "border-4 border-yellow-500" : "bg-gray-100"
//                                 }`}
//                                 style={{
//                                     width: "100%",
//                                     maxWidth: "300px",
//                                     textAlign: "center",
//                                     transition: "transform 0.3s",
//                                     transform: "translateY(0)",
//                                 }}
//                                 onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-5px)")}
//                                 onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
//                             >
//                                 <div className="text-xl font-bold mb-2">
//                                     {index === 0 && <span className="text-yellow-500">🏆 Top Performer</span>}
//                                     <div>{user.name}</div>
//                                 </div>
//                                 {/*<p className="text-sm text-gray-600 mb-4">{user.email || "Email not provided"}</p>*/}
//                                 <p className="text-2xl font-semibold text-yellow-500 mb-4">
//                                     {user.total_xp} XP
//                                 </p>
//                                 <p className="text-sm mt-4">Rank: <strong>{index + 1}</strong></p>
//                             </div>
//                         ))}
//                     </div>
//                 )}
//             </div>
//         </>
//     );
// }
//
// export default Leaderboard;

import React, { useState, useEffect } from "react";
import { API_BASE_URL } from "../../config";
import {
    Trophy,
    Medal,
    Award,
    Crown,
    Sparkles,
    Star,
    TrendingUp,
    Users,
    Target,
    Zap,
    AlertCircle,
    X,
    CheckCircle
} from "lucide-react";

const SERVER_BASE_URL = API_BASE_URL;

function Leaderboard() {

    // Get initials for avatar
    const getInitials = (name) => {
        if (!name) return "?";
        return name.split(' ').map(n => n[0]).join('').toUpperCase();
    };

    const [leaderboard, setLeaderboard] = useState([]);
    const [loading, setLoading] = useState(false);
    const [notification, setNotification] = useState({ show: false, message: "", type: "" });

    const accessToken = localStorage.getItem("accessToken");

    useEffect(() => {
        fetchLeaderboard();
    }, []);

    const fetchLeaderboard = async () => {
        setLoading(true);
        try {
            const response = await fetch(`${SERVER_BASE_URL}/admin/class-leaderboard`, {
                method: "GET",
                headers: { Authorization: `Bearer ${accessToken}` },
            });
            if (response.ok) {
                const data = await response.json();
                const sortedData = data.sort((a, b) => b.total_xp - a.total_xp); // Sort by XP
                setLeaderboard(sortedData);
                console.log("LeaderBoard:", sortedData);
            } else {
                showNotification("Failed to fetch leaderboard.", "error");
            }
        } catch (error) {
            console.error("Error fetching leaderboard:", error);
            showNotification("Error fetching leaderboard. Please try again.", "error");
        } finally {
            setLoading(false);
        }
    };

    // Show notification
    const showNotification = (message, type = "success") => {
        setNotification({
            show: true,
            message,
            type
        });

        // Hide notification after 4 seconds
        setTimeout(() => {
            setNotification({ show: false, message: "", type: "" });
        }, 4000);
    };

    // Get rank styling
    const getRankStyling = (index) => {
        switch (index) {
            case 0:
                return {
                    gradient: "from-yellow-400 via-yellow-500 to-yellow-600",
                    bgGradient: "from-yellow-50 to-yellow-100",
                    borderColor: "border-yellow-400",
                    textColor: "text-yellow-800",
                    icon: Crown,
                    iconColor: "text-yellow-600",
                    shadow: "shadow-yellow-200/50",
                    ring: "ring-yellow-300/50"
                };
            case 1:
                return {
                    gradient: "from-gray-300 via-gray-400 to-gray-500",
                    bgGradient: "from-gray-50 to-gray-100",
                    borderColor: "border-gray-400",
                    textColor: "text-gray-800",
                    icon: Medal,
                    iconColor: "text-gray-600",
                    shadow: "shadow-gray-200/50",
                    ring: "ring-gray-300/50"
                };
            case 2:
                return {
                    gradient: "from-orange-400 via-orange-500 to-orange-600",
                    bgGradient: "from-orange-50 to-orange-100",
                    borderColor: "border-orange-400",
                    textColor: "text-orange-800",
                    icon: Award,
                    iconColor: "text-orange-600",
                    shadow: "shadow-orange-200/50",
                    ring: "ring-orange-300/50"
                };
            default:
                return {
                    gradient: "from-blue-400 via-blue-500 to-blue-600",
                    bgGradient: "from-blue-50 to-blue-100",
                    borderColor: "border-blue-300",
                    textColor: "text-blue-800",
                    icon: Star,
                    iconColor: "text-blue-600",
                    shadow: "shadow-blue-200/50",
                    ring: "ring-blue-300/50"
                };
        }
    };

    // Get podium height for top 3
    const getPodiumHeight = (index) => {
        switch (index) {
            case 0:
                return "h-32"; // Tallest for 1st place
            case 1:
                return "h-24"; // Medium for 2nd place
            case 2:
                return "h-20"; // Shortest for 3rd place
            default:
                return "h-16";
        }
    };

    // Format XP with commas
    const formatXP = (xp) => {
        return xp.toLocaleString();
    };

    // Notification component
    const Notification = () => {
        if (!notification.show) return null;

        return (
            <div
                className={`fixed bottom-6 right-6 max-w-md px-6 py-4 rounded-2xl shadow-2xl backdrop-blur-lg border flex items-center z-50 font-[poppins] transform transition-all duration-300 ease-out ${notification.type === "success"
                    ? "bg-gradient-to-r from-emerald-50/95 to-emerald-100/95 text-emerald-800 border-emerald-200/50" :
                    notification.type === "error"
                        ? "bg-gradient-to-r from-red-50/95 to-red-100/95 text-red-800 border-red-200/50" :
                        "bg-gradient-to-r from-blue-50/95 to-blue-100/95 text-blue-800 border-blue-200/50"
                    }`} style={{ backdropFilter: 'blur(12px)' }}>
                <div className={`p-2 rounded-xl mr-4 ${notification.type === "success" ? "bg-emerald-500/10" :
                    notification.type === "error" ? "bg-red-500/10" : "bg-blue-500/10"
                    }`}>
                    {notification.type === "success" ?
                        <CheckCircle className="w-5 h-5" /> :
                        <AlertCircle className="w-5 h-5" />
                    }
                </div>
                <div className="flex-1">
                    <span className="font-medium">{notification.message}</span>
                </div>
                <button
                    onClick={() => setNotification({ show: false, message: "", type: "" })}
                    className="ml-4 p-1 rounded-lg hover:bg-white/20 transition-colors duration-200"
                >
                    <X className="w-4 h-4" />
                </button>
            </div>
        );
    };

    // Loading component
    const LoadingSpinner = () => (
        <div className="flex flex-col items-center justify-center py-20">
            <div className="relative mb-6">
                <div className="w-20 h-20 border-4 border-blue-100 rounded-full animate-spin"></div>
                <div
                    className="absolute top-0 left-0 w-20 h-20 border-4 border-transparent border-t-blue-600 rounded-full animate-spin"></div>
                <div
                    className="absolute top-2 left-2 w-16 h-16 border-4 border-transparent border-t-yellow-500 rounded-full animate-spin"
                    style={{ animationDirection: 'reverse', animationDuration: '1.5s' }}></div>
            </div>
            <div className="text-center">
                <h3 className="text-xl font-bold text-slate-900 mb-2">Loading Leaderboard</h3>
                <p className="text-slate-600 font-medium">Fetching the latest rankings...</p>
            </div>
        </div>
    );

    return (
        <>
            <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-50/20 font-[poppins]">
                <div className="w-full px-4 sm:px-6 lg:px-8 py-10">
                    {/* Header Section */}
                    <div className="pt-16 pb-8 text-center relative overflow-hidden">
                        <div className="absolute inset-0 "></div>
                        <div className="relative z-10">
                            {/*<div className="p-4 rounded-3xl bg-[#D67C2C] shadow-xl">*/}
                            {/*    <Trophy className="w-12 h-12 text-white"/>*/}
                            {/*</div>*/}
                            <div>
                                <h1 className="text-5xl font-bold bg-[#D67C2C] bg-clip-text text-transparent mb-4">
                                    Class Leaderboard
                                </h1>
                                <p className="text-[#1D3469] text-xl font-medium max-w-3xl mx-auto px-4">
                                    Celebrate excellence and track student achievements
                                </p>
                            </div>
                        </div>

                        {/* Stats Summary */}
                        {!loading && leaderboard.length > 0 && (
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto mb-12">
                                <div
                                    className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-xl border border-white/50">
                                    <div className="flex items-center justify-between">
                                        <div className="p-3 bg-gradient-to-r from-blue-500 to-blue-600 rounded-2xl">
                                            <Users className="w-6 h-6 text-white" />
                                        </div>
                                        <div className="text-right">
                                            <div
                                                className="text-2xl font-bold text-slate-900">{leaderboard.length}</div>
                                            <div className="text-sm font-medium text-slate-600">Total Students</div>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-xl border border-white/50">
                                    <div className="flex items-center justify-between">
                                        <div className="p-3 bg-[#D67C2C] rounded-2xl">
                                            <Zap className="w-6 h-6 text-white" />
                                        </div>
                                        <div className="text-right">
                                            <div className="text-2xl font-bold text-slate-900">
                                                {leaderboard.length > 0 ? formatXP(leaderboard[0].total_xp) : '0'}
                                            </div>
                                            <div className="text-sm font-medium text-slate-600">Highest XP</div>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-xl border border-white/50">
                                    <div className="flex items-center justify-between">
                                        <div className="p-3 bg-gradient-to-r from-green-500 to-green-600 rounded-2xl">
                                            <TrendingUp className="w-6 h-6 text-white" />
                                        </div>
                                        <div className="text-right">
                                            <div className="text-2xl font-bold text-slate-900">
                                                {leaderboard.length > 0 ? Math.round(leaderboard.reduce((acc, user) => acc + user.total_xp, 0) / leaderboard.length) : 0}
                                            </div>
                                            <div className="text-sm font-medium text-slate-600">Average XP</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Loading State */}
                    {loading && <LoadingSpinner />}

                    {/* Empty State */}
                    {!loading && leaderboard.length === 0 && (
                        <div
                            className="bg-white/80 backdrop-blur-sm rounded-3xl shadow-xl p-16 text-center border border-white/50">
                            <div
                                className="w-32 h-32 mx-auto mb-8 bg-gradient-to-br from-slate-100 to-slate-200 rounded-full flex items-center justify-center">
                                <Trophy className="h-16 w-16 text-slate-400" />
                            </div>
                            <h3 className="text-3xl font-bold text-slate-900 mb-4">No Rankings Yet</h3>
                            <p className="text-xl text-slate-600 font-medium mb-8 max-w-md mx-auto">
                                The leaderboard is empty. Students will appear here as they earn XP through activities
                                and achievements.
                            </p>
                            <button
                                onClick={fetchLeaderboard}
                                className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold rounded-2xl shadow-lg hover:from-blue-700 hover:to-indigo-700 transform hover:scale-105 transition-all duration-200"
                            >
                                <Sparkles size={20} className="mr-2" />
                                Refresh Leaderboard
                            </button>
                        </div>
                    )}

                    {/* Leaderboard */}
                    {!loading && leaderboard.length > 0 && (
                        <>
                            {/* Top 3 Podium */}
                            {leaderboard.length >= 3 && (
                                <div className="mb-16">
                                    <div className="flex justify-center items-end space-x-8 mb-8">
                                        {/* 2nd Place */}
                                        <div className="flex flex-col items-center">
                                            <div
                                                className="bg-white/90 backdrop-blur-sm rounded-3xl p-6 shadow-2xl border border-white/60 mb-4 transform hover:scale-105 transition-all duration-300">
                                                <div className="text-center">
                                                    <div
                                                        className="w-20 h-20 mx-auto mb-4 bg-gradient-to-br from-gray-400 to-gray-600 rounded-full flex items-center justify-center shadow-lg">
                                                        {/*<span className="text-2xl font-bold text-white">*/}
                                                        {/*  {leaderboard[1].name.split(' ').map(n => n[0]).join('').slice(0, 2)}*/}
                                                        {/*</span>*/}

                                                        {leaderboard[1].profile_picture_url ? (
                                                            <img
                                                                src={SERVER_BASE_URL + leaderboard[1].profile_picture_url}
                                                                alt={leaderboard[1].name}
                                                                className="h-12 w-12 rounded-full object-cover border-2 border-[#F7D1B6]"
                                                            />
                                                        ) : (
                                                            <div
                                                                className="h-12 w-12 rounded-full bg-[#FFF8F4] flex items-center justify-center text-xl text-[#F17C45] font-medium border-2 border-[#F7D1B6]">
                                                                {getInitials(leaderboard[1].name)}
                                                            </div>
                                                        )}

                                                    </div>
                                                    <h3 className="text-lg font-bold text-slate-900 mb-2">{leaderboard[1].name}</h3>
                                                    <div className="flex items-center justify-center space-x-2 mb-3">
                                                        <Medal className="w-5 h-5 text-gray-500" />
                                                        <span
                                                            className="text-2xl font-bold text-gray-700">{formatXP(leaderboard[1].total_xp)}</span>
                                                        <span className="text-sm font-medium text-slate-600">XP</span>
                                                    </div>
                                                    <div
                                                        className="px-4 py-2 bg-gradient-to-r from-gray-100 to-gray-200 rounded-full">
                                                        <span
                                                            className="text-sm font-bold text-gray-700">2nd Place</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                className="w-24 h-24 bg-gradient-to-t from-gray-300 to-gray-500 rounded-t-2xl shadow-lg"></div>
                                        </div>

                                        {/* 1st Place - Taller */}
                                        <div className="flex flex-col items-center -mt-8">
                                            <div
                                                className="bg-white/90 backdrop-blur-sm rounded-3xl p-8 shadow-2xl border border-[#D67C2C] mb-4 transform hover:scale-105 transition-all duration-300 ring-4 ring-[#D67C2C]">
                                                <div className="text-center">
                                                    <div className="relative">
                                                        <div
                                                            className="w-24 h-24 mx-auto mb-4 bg-[#D67C2C] rounded-full flex items-center justify-center shadow-xl">
                                                            {/*<span className="text-3xl font-bold text-white">*/}
                                                            {/*  {leaderboard[0].name.split(' ').map(n => n[0]).join('').slice(0, 2)}*/}
                                                            {/*</span>*/}
                                                            {/*                              */}
                                                            {leaderboard[0].profile_picture_url ? (
                                                                <img
                                                                    src={SERVER_BASE_URL + leaderboard[0].profile_picture_url}
                                                                    alt={leaderboard[0].name}
                                                                    className="h-12 w-12 rounded-full object-cover border-2 border-[#F7D1B6]"
                                                                />
                                                            ) : (
                                                                <div
                                                                    className="h-12 w-12 rounded-full bg-[#FFF8F4] flex items-center justify-center text-xl text-[#F17C45] font-medium border-2 border-[#F7D1B6]">
                                                                    {getInitials(leaderboard[0].name)}
                                                                </div>
                                                            )}

                                                        </div>
                                                        <div
                                                            className="absolute -top-2 -right-2 w-8 h-8 bg-[#D67C2C] rounded-full flex items-center justify-center shadow-lg">
                                                            <Crown className="w-4 h-4 text-white" />
                                                        </div>
                                                    </div>
                                                    <h3 className="text-xl font-bold text-slate-900 mb-2">{leaderboard[0].name}</h3>
                                                    <div className="flex items-center justify-center space-x-2 mb-4">
                                                        <Trophy className="w-6 h-6 text-orange-600" />
                                                        <span
                                                            className="text-3xl font-bold text-orange-600">{formatXP(leaderboard[0].total_xp)}</span>
                                                        <span className="text-sm font-medium text-slate-600">XP</span>
                                                    </div>
                                                    <div
                                                        className="px-6 py-2 bg-[#D67C2C] rounded-full shadow-lg">
                                                        <span className="text-sm font-bold text-white">🏆 Champion</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                className="w-32 h-32 bg-[#D67C2C] rounded-t-2xl shadow-xl"></div>
                                        </div>

                                        {/* 3rd Place */}
                                        <div className="flex flex-col items-center">
                                            <div
                                                className="bg-white/90 backdrop-blur-sm rounded-3xl p-6 shadow-2xl border border-white/60 mb-4 transform hover:scale-105 transition-all duration-300">
                                                <div className="text-center">
                                                    <div
                                                        className="w-20 h-20 mx-auto mb-4 bg-gradient-to-br from-orange-400 to-orange-600 rounded-full flex items-center justify-center shadow-lg">
                                                        {/*<span className="text-2xl font-bold text-white">*/}
                                                        {/*  {leaderboard[2].name.split(' ').map(n => n[0]).join('').slice(0, 2)}*/}
                                                        {/*</span>*/}
                                                        {/*                            */}
                                                        {leaderboard[2].profile_picture_url ? (
                                                            <img
                                                                src={SERVER_BASE_URL + leaderboard[2].profile_picture_url}
                                                                alt={leaderboard[2].name}
                                                                className="h-12 w-12 rounded-full object-cover border-2 border-[#F7D1B6]"
                                                            />
                                                        ) : (
                                                            <div
                                                                className="h-12 w-12 rounded-full bg-[#FFF8F4] flex items-center justify-center text-xl text-[#F17C45] font-medium border-2 border-[#F7D1B6]">
                                                                {getInitials(leaderboard[2].name)}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <h3 className="text-lg font-bold text-slate-900 mb-2">{leaderboard[2].name}</h3>
                                                    <div className="flex items-center justify-center space-x-2 mb-3">
                                                        <Award className="w-5 h-5 text-orange-500" />
                                                        <span
                                                            className="text-2xl font-bold text-orange-700">{formatXP(leaderboard[2].total_xp)}</span>
                                                        <span className="text-sm font-medium text-slate-600">XP</span>
                                                    </div>
                                                    <div
                                                        className="px-4 py-2 bg-gradient-to-r from-orange-100 to-orange-200 rounded-full">
                                                        <span
                                                            className="text-sm font-bold text-orange-700">3rd Place</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                className="w-20 h-20 bg-gradient-to-t from-orange-400 to-orange-600 rounded-t-2xl shadow-lg"></div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Full Leaderboard List */}
                            <div className="space-y-4">
                                <div className="text-center mb-8">
                                    <h2 className="text-2xl font-bold text-slate-900 mb-2">Complete Rankings</h2>
                                    <p className="text-slate-600 font-medium">Full leaderboard with all student
                                        rankings</p>
                                </div>

                                <div className="grid gap-4">
                                    {leaderboard.map((user, index) => {
                                        const styling = getRankStyling(index);
                                        const IconComponent = styling.icon;

                                        return (
                                            <div
                                                key={user.student_id}
                                                className={`group relative bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-xl border border-white/60 hover:shadow-2xl transform hover:scale-[1.02] transition-all duration-300 ${styling.shadow} hover:${styling.ring} hover:ring-4`}
                                                style={{ animationDelay: `${index * 100}ms` }}
                                            >
                                                <div className="flex items-center space-x-6">
                                                    {/* Rank Number */}
                                                    <div
                                                        className={`flex-shrink-0 w-16 h-16 bg-gradient-to-br ${styling.gradient} rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                                                        <span
                                                            className="text-2xl font-bold text-white">#{index + 1}</span>
                                                    </div>

                                                    {/* User Avatar */}
                                                    <div className="relative">
                                                        <div
                                                            className={`w-16 h-16 bg-gradient-to-br ${styling.bgGradient} rounded-2xl flex items-center justify-center shadow-lg border-2 ${styling.borderColor}`}>
                                                            {/*<span className={`text-xl font-bold ${styling.textColor}`}>*/}
                                                            {/*  {user.name.split(' ').map(n => n[0]).join('').slice(0, 2)}*/}
                                                            {/*</span>*/}

                                                            {user.profile_picture_url ? (
                                                                <img
                                                                    src={SERVER_BASE_URL + user.profile_picture_url}
                                                                    alt={user.name}
                                                                    className="h-12 w-12 rounded-full object-cover border-2 border-[#F7D1B6]"
                                                                />
                                                            ) : (
                                                                <div
                                                                    className="h-12 w-12 rounded-full bg-[#FFF8F4] flex items-center justify-center text-xl text-[#F17C45] font-medium border-2 border-[#F7D1B6]">
                                                                    {getInitials(user.name)}
                                                                </div>
                                                            )}
                                                        </div>
                                                        {index < 3 && (
                                                            <div
                                                                className={`absolute -top-2 -right-2 w-8 h-8 bg-gradient-to-r ${styling.gradient} rounded-full flex items-center justify-center shadow-lg`}>
                                                                <IconComponent className="w-4 h-4 text-white" />
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* User Info */}
                                                    <div className="flex-1 min-w-0">
                                                        <div className="flex items-center space-x-3 mb-2">
                                                            <h3 className="text-xl font-bold text-slate-900 truncate">{user.name}</h3>
                                                            {index === 0 && (
                                                                <div className="flex items-center space-x-1">
                                                                    <Sparkles className="w-5 h-5 text-orange-500" />
                                                                    <span
                                                                        className="text-sm font-bold text-orange-600 bg-yellow-100 px-2 py-1 rounded-full">
                                                                        Top Performer
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {user.email && (
                                                            <p className="text-slate-600 font-medium text-sm truncate">{user.email}</p>
                                                        )}
                                                    </div>

                                                    {/* XP Display */}
                                                    <div className="text-right">
                                                        <div className="flex items-center space-x-2 mb-1">
                                                            <Zap className={`w-5 h-5 ${styling.iconColor}`} />
                                                            <span
                                                                className="text-3xl font-bold text-slate-900">{formatXP(user.total_xp)}</span>
                                                            <span
                                                                className="text-sm font-medium text-slate-600">XP</span>
                                                        </div>
                                                        <div
                                                            className={`inline-flex items-center px-3 py-1 bg-gradient-to-r ${styling.bgGradient} ${styling.textColor} text-sm font-semibold rounded-full border ${styling.borderColor}`}>
                                                            <Target className="w-4 h-4 mr-1" />
                                                            Rank {index + 1}
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Achievement Badges for Top 3 */}
                                                {index < 3 && (
                                                    <div className="mt-4 pt-4 border-t border-slate-200">
                                                        <div className="flex items-center justify-center space-x-2">
                                                            <div
                                                                className={`px-3 py-1 bg-gradient-to-r ${styling.bgGradient} ${styling.textColor} text-xs font-bold rounded-full border ${styling.borderColor}`}>
                                                                {index === 0 ? '🏆 CHAMPION' : index === 1 ? '🥈 RUNNER-UP' : '🥉 THIRD PLACE'}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </>
                    )}

                    <Notification />
                </div>
            </div>
        </>
    );
}

export default Leaderboard;